/**
 * Results tab lock for team members — avoids flicker while FC sessions refresh
 * when the user has already completed functional capacity.
 */
export function employeeResultsTabLocked(
  employeeId: string | null,
  fcComplete: boolean,
  fcCompleteSticky: boolean,
): boolean {
  if (!employeeId) return true;
  return !fcComplete && !fcCompleteSticky;
}
